import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY } from '@theme_color';

const color_gray = '#4B5563';
const font = '"Plus Jakarta Sans", sans-serif';

const useStyles = makeStyles((theme) => ({
    offline: {
        color: '#000',
        background: '#fff',
        height: '100vh',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    body: {
        fontFamily: font,
        margin: 0,
    },
    wrapper: {
        margin: 0,
    },
    desc: {
        display: 'block',
    },
    h1: {
        fontFamily: font,
        display: 'block',
        color: PRIMARY,
        fontSize: 18,
        fontWeight: 700,
        marginTop: 24,
        marginBottom: 0,
    },
    h2: {
        fontFamily: font,
        fontSize: '3rem',
        fontWeight: 700,
        margin: 0,
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
        },
    },
    info: {
        fontFamily: font,
        color: color_gray,
        fontSize: 18,
        marginTop: 10,
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('xs')]: {
            width: 250,
        },
    },
    actions: {
        marginTop: 40,
        '& button': {
            padding: '14px 26px',
            borderRadius: 6,
            fontSize: '1rem',
            fontWeight: 700,
            textTransform: 'none',
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.8rem',
            },
        },
    },
}));

export default useStyles;
